<div class="card-container" [ngClass]="{ 'only-image': onlyImage, 'mobile': isMobile }" *ngIf="application">
  <div class="media-section" [ngClass]="{ 'mobile': isMobile }">
    <div class="blur-gradient" *ngIf="isHotOfferItem(application) && onlyImage" (click)="navigateToAnotherPage(application.id)"></div>
    <div class="overview-header">
      <div class="agent-info" *ngIf="isHotOfferItem(application) && application.agent" (click)="navigateToAgentPage(application?.agent?.id)">
        <img class="agent-avatar" [src]="urlPhoto(application.agent.photoUuid)" (error)="onAvatarError($event)" [alt]="application.agent.fullName">
        <span class="agent-name"> {{ application.agent.fullName }}</span>
      </div>
      <div class="actions-panel">
        <button class="action-button hot-button" *ngIf="isHotOffer && isBurn">
          <img src="assets/images/new-design-icons/hot.svg">
        </button>
        <button class="action-button favorite-button" (click)="toggleFavorite()" *ngIf="isHotOfferItem(application) && isLiked">
          <img src="assets/images/new-design-icons/{{application.isFavorite ? 'liked' : 'unliked'}}.svg">
        </button>
      </div>
    </div>

    <div class="gallery-photo">
      <ng-container *ngIf="application.photoIdList && application.photoIdList.length; else emptyImageList">
        <p-carousel class="image-list" [value]="application.photoIdList" [showIndicators]="application.photoIdList.length > 1" [showNavigators]="application.photoIdList.length > 1"
          [numVisible]="1" [numScroll]="1" [circular]="false" indicatorStyleClass="indicators">
          <ng-template let-image pTemplate="item">
            <img (error)="onImageError($event)" class="photo" [src]="image" alt="image" loading="lazy" (click)="navigateToAnotherPage(application.id)">
          </ng-template>
        </p-carousel>
      </ng-container>

      <ng-template #emptyImageList>
          <img class="photo" src="assets/images/1x_no_image_and_video.png" alt="no-photo" loading="lazy" (click)="navigateToAnotherPage(application.id)">
      </ng-template>
    </div>

    <div class="coast-block" *ngIf="isHotOfferItem(application) && onlyImage">{{ application.price | mask : 'separator.2' }} ₸</div>
  </div>

  <ng-container *ngIf="!onlyImage">
    <div class="clickable-block" *ngIf="isHotOfferItem(application)" (click)="navigateToAnotherPage(application.id)">
      <div class="info-header" *ngIf="application.residentialComplexName || application.viewCount">
        <h2 *ngIf="application.residentialComplexName" class=" name-residential" [class.item-left]="!application.viewCount" [class.big]="isNewBuildings">{{ application.residentialComplexName }}</h2>
        <p class="property-stats view-count" [class.item-right]="!application.residentialComplexName" *ngIf="application.viewCount">
          <span class="views"><i class="pi pi-eye"></i> <span class="count">{{ application.viewCount }}</span></span>
        </p>
      </div>
      <p class="price" *ngIf="isShowPrice">
        {{ application.price | mask : 'separator.2' }} ₸
      </p>
      <div class="address">
        {{ application.address }} · {{application.roominess }} · {{ application.area }} м<sup>2</sup> · {{ application.surface }}
      </div>
    </div>

    <div *ngIf="isNewBuilding(application)" class="building-block">
      <div class="info-header" *ngIf="application.houseName || application.rating">
        <div *ngIf="application.houseName" class="iname-residential" [class.item-left]="!application.rating" [class.big]="isNewBuildings">{{ application.houseName }}</div>
        <p class="property-stats mark" *ngIf="application.rating" [class.item-right]="!application.houseName">
          <span class="marks"><i class="pi pi-star-fill"></i> <span class="count"> {{ application.rating }}</span></span>
        </p>
      </div>
      <p class="builder" *ngIf="application.developerName">
        Застройщик: {{ application.developerName }}
      </p>
      <p class="address" *ngIf="application.address">
        {{ application.address }}
      </p>
    </div>
    <app-button class="button-action"
                *ngIf="isHotOffer"
                [text]="textButton"
                [icon]="'assets/images/new-design-icons/phone.svg'"
                iconDirection="left"
                buttonClass="big-transparent"
                borderClass="border-ash"
                (buttonClick)="showPhone()"
    ></app-button>

    <app-button class="button-action"
                *ngIf="isNewBuildings"
                [text]="'Подробнее'"
                buttonClass="big-transparent"
                borderClass="border-ash"
                (buttonClick)="navigateToAnotherPage(application.id)"
    ></app-button>
  </ng-container>
</div>
